import React from "react";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: "primary" | "secondary" | "ghost";
    icon?: React.ReactNode;
    trailing?: React.ReactNode;
};

export function HFButton({
    variant = "primary",
    icon,
    trailing,
    className = "",
    children,
    ...rest
}: ButtonProps) {
    const base = "hf-btn";
    const v =
        variant === "primary"
            ? "hf-btn-primary"
            : variant === "secondary"
              ? "hf-btn-secondary"
              : "hf-btn-ghost";
    return (
        <button {...rest} className={`${base} ${v} ${className}`.trim()}>
            {icon}
            <span>{children}</span>
            {trailing}
        </button>
    );
}

type LinkButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    variant?: "primary" | "secondary" | "ghost";
    icon?: React.ReactNode;
    trailing?: React.ReactNode;
};

export function HFLinkButton({
    variant = "primary",
    icon,
    trailing,
    className = "",
    children,
    ...rest
}: LinkButtonProps) {
    const base = "hf-btn";
    const v =
        variant === "primary"
            ? "hf-btn-primary"
            : variant === "secondary"
              ? "hf-btn-secondary"
              : "hf-btn-ghost";
    return (
        <a {...rest} className={`${base} ${v} ${className}`.trim()}>
            {icon}
            <span>{children}</span>
            {trailing}
        </a>
    );
}

export function Container({
    children,
    className = "",
}: {
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <div
            className={`max-w-[1440px] mx-auto px-6 md:px-10 ${className}`.trim()}
        >
            {children}
        </div>
    );
}

export function SectionHeader({
    eyebrow,
    title,
    lead,
    align = "left",
    testId,
}: {
    eyebrow?: string;
    title: string | React.ReactNode;
    lead?: string;
    align?: "left" | "center";
    testId?: string;
}) {
    return (
        <div
            className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl mb-10 md:mb-14`}
            data-testid={testId}
        >
            {eyebrow && <div className="hf-eyebrow">{eyebrow}</div>}
            <h2 className="mt-3 font-display text-3xl sm:text-4xl md:text-5xl leading-[1.1] text-hf-ink">
                {title}
            </h2>
            {lead && (
                <p className="mt-5 text-base md:text-lg text-hf-muted leading-relaxed">
                    {lead}
                </p>
            )}
        </div>
    );
}

export function GoldUnderline({ className = "" }: { className?: string }) {
    return (
        <span
            className={`inline-block w-8 h-px ${className}`.trim()}
            style={{ background: "hsl(var(--hf-gold))" }}
        />
    );
}
